import Vue from 'vue';
import { Util } from '../util';

const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

export default Vue.filter('diasSemana', function (arreglo) {
    if (!arreglo || !arreglo.length) return 'Ninguno';
    if (arreglo.length == 7) return 'Todos los días';
    
    const arregloDias = arreglo.map(numero => dias[numero-1]);

    let cadena = '';
    for (let i = 0; i < arregloDias.length; i++) {
        cadena = Util.agregarACadenaConComa(cadena, arregloDias[i]);
    }

    return cadena;
});